<section class="dashboard">
  <div class="page">
    <div>
      <div>
        <div class="bg-dashboard">
          <div class="dashboardheader">
            <div class="logoinfo">
              <img
                height="100px"
                *ngIf="!isLoading"
                loading="lazy"
                [src]="logoFilePath"
                [alt]="'ClientApp.FrontOffice.Review.Dashboard.RestaurantIcon' | translate" />
              <img
                height="100px"
                *ngIf="isLoading"
                loading="lazy"
                src="./assets/images/icons/icon-96x96.png"
                [alt]="'ClientApp.FrontOffice.Review.Dashboard.SymbolOfSepidz' | translate" />
              <div class="branch-title">
                <h4>{{ "ClientApp.FrontOffice.Review.Dashboard.SepidzSoftWare" | translate }}</h4>

                <span *ngIf="hasBranch">
                  <span class="color-949494">{{ "ClientApp.FrontOffice.Review.Dashboard.Branch" | translate }} {{ model?.Info?.BranchTitle }}</span>
                </span>
                <span *ngIf="!hasBranch">
                  <span class="color-949494">{{ currentInformation?.CustomerName }}</span>
                </span>
              </div>
            </div>
            <div class="item-contain">
              <div class="item">
                <i class="icon-date_range-f d-icon"></i>
                <span class="color-949494">{{ today }}</span>
              </div>
              <div class="item">
                <span class="color-949494"
                  >{{ "ClientApp.FrontOffice.Review.Dashboard.SaftWareVersion" | translate }} {{ currentInformation?.ProductVersion }}</span
                >
              </div>
            </div>
            <div class="contact-us">
              <ssg-button (click)="openContactUsModal()" [label]="'ClientApp.FrontOffice.Review.Dashboard.Calling' | translate"></ssg-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="dashboard-filter">
        <div class="dashboardfilter">
          <div class="filterinfo">
            <div class="filter-title">
              <i class="icon-filter_list"></i>
              <span class="filter_list-text">
                {{ "ClientApp.FrontOffice.Review.Dashboard.FilterList" | translate }}
              </span>
            </div>
            <div class="interval-btn">
              <div class="filterbtn">
                <ssg-button
                  [label]="'ClientApp.FrontOffice.Review.Dashboard.Today' | translate"
                  [ngStyle]="timeInterval === 'Daily' ? { 'background-color': 'rgba(176, 196, 222, 1)', color: '#283593' } : undefined"
                  (click)="load('Daily')"></ssg-button>
              </div>
              <div class="filterbtn">
                <ssg-button
                  [label]="'ClientApp.FrontOffice.Review.Dashboard.Weekend' | translate"
                  [ngStyle]="timeInterval === 'Weekly' ? { 'background-color': 'rgba(176, 196, 222, 1)', color: '#283593' } : undefined"
                  (click)="load('Weekly')"></ssg-button>
              </div>
              <div class="filterbtn">
                <ssg-button
                  [label]="'ClientApp.FrontOffice.Review.Dashboard.Month' | translate"
                  [ngStyle]="timeInterval === 'Monthly' ? { 'background-color': 'rgba(176, 196, 222, 1)', color: '#283593' } : undefined"
                  (click)="load('Monthly')"></ssg-button>
              </div>
              <div class="filterbtn">
                <ssg-button
                  [label]="'ClientApp.FrontOffice.Review.Dashboard.Year' | translate"
                  [ngStyle]="timeInterval === 'Yearly' ? { 'background-color': 'rgba(176, 196, 222, 1)', color: '#283593' } : undefined"
                  (click)="load('Yearly')"></ssg-button>
              </div>
            </div>
          </div>
          <div class="filterbtn resetbtn">
            <ssg-button
              [label]="'ClientApp.FrontOffice.Review.Dashboard.Reset' | translate"
              (click)="load(timeInterval)"
              class="color-545454"></ssg-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div class="kpi-container" *ngIf="!isLoading">
          <sepidz-kpi-widget
            type="number"
            [data]="model.Kpi.Sale"
            *hasPermission="['RestaurantSale:Dashboard/ReadSaleAmount', 'Same']"
            background="kpi-colr1"
            icon="icon-addchart-o">
          </sepidz-kpi-widget>

          <sepidz-kpi-widget
            type="time"
            [data]="model.Kpi.PreparationTime"
            *hasPermission="['RestaurantSale:Dashboard/ReadPreparationTimeAmount', 'Same']"
            background="kpi-colr2"
            icon="icon-watch_later-o">
          </sepidz-kpi-widget>
          <sepidz-kpi-widget
            type="time"
            [data]="model.Kpi.DeliverTime"
            *hasPermission="['RestaurantSale:Dashboard/ReadDeliverTimeAmount', 'Same']"
            background="kpi-colr3"
            icon=" icon-moped-o">
          </sepidz-kpi-widget>

          <sepidz-kpi-widget
            type="time"
            [data]="model.Kpi.PreparationTillDelivery"
            *hasPermission="['RestaurantSale:Dashboard/ReadAveragePreparationTillDelivery', 'Same']"
            background="kpi-colr4"
            icon=" icon-moped-o">
          </sepidz-kpi-widget>

          <sepidz-kpi-widget
            [data]="model.Kpi.DebitCredit"
            *hasPermission="['RestaurantSale:Dashboard/ReadDebitCreditAmount', 'Same']"
            background="kpi-colr5"
            icon="icon-dollar-bill-and-coins">
          </sepidz-kpi-widget>
        </div>
      </div>
    </div>
    <div>
      <div></div>
      <div class="sepidz-chart" *ngIf="!isLoading">
        <sepidz-bar-chart
          *ngIf="isMultiBranch && BranchAmountSaleComparisonSummary"
          [data]="model.Chart.ReadBranchSaleAmount"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#4DB6AC',
              pointBackgroundColor: '#4DB6AC',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4DB6AC'
            },
            {
              backgroundColor: '#00695C',
              borderColor: '#004D40',
              pointBackgroundColor: '#004D40',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#004D40'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.ReadBranchSaleAmount' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>
        <sepidz-bar-chart
          *ngIf="isMultiBranch && BranchQuantitySaleComparisonSummary"
          [data]="model.Chart.ReadBranchSaleQuantity"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#4DB6AC',
              pointBackgroundColor: '#4DB6AC',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4DB6AC'
            },
            {
              backgroundColor: '#00695C',
              borderColor: '#004D40',
              pointBackgroundColor: '#004D40',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#004D40'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.ReadBranchSaleQuantity' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadSaleAmountPerSaleMethod', 'Same']"
          [data]="model.Chart.SaleAmountPerSaleMethod"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#4DB6AC',
              pointBackgroundColor: '#4DB6AC',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4DB6AC'
            },
            {
              backgroundColor: '#00695C',
              borderColor: '#004D40',
              pointBackgroundColor: '#004D40',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#004D40'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.SaleAmountPerSaleMethod' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadSaleAmountPerItemCategory', 'Same']"
          [data]="model.Chart.SaleAmountPerCategory"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#7986CB',
              borderColor: '#5C6BC0',
              pointBackgroundColor: '#5C6BC0',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#5C6BC0'
            },
            {
              backgroundColor: '#3949AB',
              borderColor: '#303F9F',
              pointBackgroundColor: '#303F9F',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#303F9F'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.SaleAmountPerItemCategory' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadSaleAmountPerUser', 'Same']"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [data]="model.Chart.SaleAmountPerUser"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#e57373',
              borderColor: '#e57373',
              pointBackgroundColor: '#e57373',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#e57373'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.SaleAmountPerUser' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-pie-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadDeliveryInvoiceCountPerStatus', 'Same']"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [data]="model.Chart.DeliveryInvoiceCountPerStatus"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[{ backgroundColor: ['#89cff0', '#56a0d3', '#0073cf', '#0f52ba', '#1c39bb', '#010080', '#191970', '#002146'] }]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.DeliveryInvoiceCountPerStatus' | translate"
          [labelEnabled]="true">
        </sepidz-pie-chart>

        <sepidz-doughnut-chart
          [colors]="[{ backgroundColor: ['#89cff0', '#56a0d3', '#0073cf', '#0f52ba', '#1c39bb', '#010080', '#191970', '#002146'] }]"
          *hasPermission="['RestaurantSale:Dashboard/ReadRestaurantInvoiceCountPerStatus', 'Same']"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [data]="model.Chart.RestaurantInvoiceCountPerStatus"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.RestaurantInvoiceCountPerStatus' | translate"
          [labelEnabled]="true">
        </sepidz-doughnut-chart>

        <sepidz-pie-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadFastFoodInvoiceCountPerStatus', 'Same']"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [data]="model.Chart.FastFoodInvoiceCountPerStatus"
          [colors]="[{ backgroundColor: ['#89cff0', '#56a0d3', '#0073cf', '#0f52ba', '#1c39bb', '#010080', '#191970', '#002146'] }]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.FastFoodInvoiceCountPerStatus' | translate"
          [labelEnabled]="true">
        </sepidz-pie-chart>
        <sepidz-line-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadSaleAmountPerHour', 'Same']"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [data]="model.Chart.SaleAmountPerHour"
          [ratio]="1000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: 'rgba(255,223,235,0.5)',
              borderColor: 'rgba(252,160,195,0.5)',
              pointBackgroundColor: 'rgba(252,160,195,0.5)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(252,160,195,0.5)'
            },
            {
              backgroundColor: 'rgba(255,35,105,0.5)',
              borderColor: 'rgba(253,12,89,0.5)',
              pointBackgroundColor: 'rgba(253,12,89,0.5)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(253,12,89,0.5)'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.SaleAmountPerHour' | translate"
          [tooltipEnabled]="true"></sepidz-line-chart>

        <sepidz-line-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadSaleAmountPerDayOfWeek', 'Same']"
          [data]="model.Chart.SaleAmountPerDayOfWeek"
          [legend]="true"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: 'rgba(137,225,232,0.5)',
              borderColor: 'rgba(120,190,195,0.2)',
              pointBackgroundColor: 'rgba(120,190,195,0.2)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(120,190,195,0.2)'
            },
            {
              backgroundColor: 'rgba(11,49,96,0.5)',
              borderColor: 'rgba(4,35,75,0.2)',
              pointBackgroundColor: 'rgba(4,35,75,0.2)',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(4,35,75,0.2)'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.SaleAmountPerDayOfWeek' | translate"
          [tooltipEnabled]="true">
        </sepidz-line-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadCancelledInvoiceCountPerUser', 'Same']"
          [data]="model.Chart.CanceledInvoiceCountPerUser"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#fda007',
              borderColor: '#c87f07',
              pointBackgroundColor: '#c87f07',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#c87f07'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.CanceledInvoiceCountPerUser' | translate"
          [tooltipEnabled]="true"></sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadNegativeEditSumPerUser', 'Same']"
          [data]="model.Chart.UserNegativeEditSum"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#a2b86c',
              borderColor: '#869f47',
              pointBackgroundColor: '#869f47',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#869f47'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.UserNegativeEditSum' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadReprintForPreparationCountPerUser', 'Same']"
          [data]="model.Chart.UserPreparationReprint"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#1395ba',
              borderColor: '#869f47',
              pointBackgroundColor: '#869f47',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#869f47'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.UserPreparationReprint' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>
        <!-- <sepidz-doughnut-chart *hasPermission="['RestaurantSale:Dashboard/ReadReprintForPreparationCountPerUser','Same']"
                               [colors]="[{backgroundColor: ['#1395ba', '#117899', '#0f5b78', '#0d3c55', '#c02e1d', '#d94e1f', '#f16c20', '#ef8b2c', '#ecaa38', '#ebc844', '#a2b86c', '#5ca793']}]"
                               [legend]="true"
                               [ratio]="1000000"
                               [stackedX]="false" [stackedY]="false"
                               [legendLabels]="TimeIntervalLabels[timeInterval]"
                               [data]="model.Chart.UserPreparationReprint"
                               title="چاپ مجدد آماده‌سازی کاربران"
                               [labelEnabled]="true">
        </sepidz-doughnut-chart> -->
        <!--
        <sepidz-doughnut-chart *hasPermission="['RestaurantSale:Dashboard/ReadReprintForCustomerCountPerUser','Same']"
                               [colors]="[{backgroundColor: ['#1395ba', '#117899', '#0f5b78', '#0d3c55', '#c02e1d', '#d94e1f', '#f16c20', '#ef8b2c', '#ecaa38', '#ebc844', '#a2b86c', '#5ca793']}]"
                               [data]="model.Chart.UserCustomerReprint"
                               [legend]="true"
                               [ratio]="1000000"
                               [stackedX]="false" [stackedY]="false"
                               [legendLabels]="TimeIntervalLabels[timeInterval]"
                               title="چاپ مجدد مشتری کاربران"
                               [labelEnabled]="true">
        </sepidz-doughnut-chart> -->
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadReprintForCustomerCountPerUser', 'Same']"
          [data]="model.Chart.UserCustomerReprint"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#1395ba',
              borderColor: '#869f47',
              pointBackgroundColor: '#869f47',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#869f47'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.UserCustomerReprint' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadInvoiceCountPerUser', 'Same']"
          [data]="model.Chart.InvoiceCountPerUser"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#9575CD',
              borderColor: '#673AB7',
              pointBackgroundColor: '#673AB7',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#673AB7'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.InvoiceCountPerUser' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadInvoiceCountPerDriver', 'Same']"
          [data]="model.Chart.InvoiceCountPerDriver"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#00897B',
              pointBackgroundColor: '#00897B',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#00897B'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.InvoiceCountPerDriver' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadInvoiceCountPerWaiter', 'Same']"
          [data]="model.Chart.InvoiceCountPerWaiter"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#81C784',
              borderColor: '#4CAF50',
              pointBackgroundColor: '#4CAF50',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4CAF50'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.InvoiceCountPerWaiter' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadDebitAmountPerUser', 'Same']"
          [data]="model.Chart.UserDebit"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#376c8a',
              borderColor: '#20506b',
              pointBackgroundColor: '#20506b',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#20506b'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.UserDebit' | translate"
          [tooltipEnabled]="true"></sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadDebitAmountPerDriver', 'Same']"
          [data]="model.Chart.DriverDebit"
          [legend]="true"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [legendLabels]="TimeIntervalLabels[timeInterval]"
          [colors]="[
            {
              backgroundColor: '#ff5657',
              borderColor: '#FF5722',
              pointBackgroundColor: '#FF5722',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#FF5722'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.DebitAmountPerDriver' | translate"
          [tooltipEnabled]="true">
        </sepidz-bar-chart>

        <sepidz-pie-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadCallCountPerStatus', 'Same']"
          [colors]="[{ backgroundColor: ['#fdb338', '#025196'] }]"
          [legend]="true"
          [data]="model.Chart.CallCountPerStatus"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.CallCountPerStatus' | translate"
          [labelEnabled]="true">
        </sepidz-pie-chart>

        <sepidz-pie-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadTableCountPerStatus', 'Same']"
          [colors]="[{ backgroundColor: ['#ff5657', '#376c8a', '#f2d9bb', '#638fa9'] }]"
          [legend]="true"
          [data]="model.Chart.TableCountPerStatus"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.TableCountPerStatus' | translate"
          [labelEnabled]="true">
        </sepidz-pie-chart>

        <sepidz-pie-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadInvoiceCountPerDeliverStatus', 'Same']"
          [legend]="true"
          [data]="model.Chart.InvoiceCountPerDeliverStatus"
          [colors]="[{ backgroundColor: ['#ff2369', '#ffacbc', '#ffe3e8', '#00d4f9', '#00a7c9', '#ce607d'] }]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.InvoiceCountPerDeliverStatus' | translate"
          [labelEnabled]="true"></sepidz-pie-chart>
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadCustomersWithMaximumDebit', 'Same']"
          [data]="model.Chart.CustomerWithMaximumDebit"
          [legend]="false"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#376c8a',
              borderColor: '#20506b',
              pointBackgroundColor: '#20506b',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#20506b'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.CustomerWithMaximumDebit' | translate"
          [tooltipEnabled]="true"></sepidz-bar-chart>

        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadDeletedInvoicePerSaleMethodBranch', 'Same']"
          [data]="model.Chart.ReadDeletedInvoicePerSaleMethodBranch"
          [legend]="false"
          [ratio]="1000000"
          [stackedX]="false"
          [stackedY]="false"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#4DB6AC',
              pointBackgroundColor: '#4DB6AC',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4DB6AC'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.DeletedInvoicePerSaleMethodBranch' | translate"
          [tooltipEnabled]="true"></sepidz-bar-chart>
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadPreparationTimeAveragePerSaleMethodBranch', 'Same']"
          [data]="model.Chart.ReadPreparationTimeAveragePerSaleMethodBranch"
          [legend]="false"
          [ratio]="1000000"
          [legend]="false"
          [stackedX]="true"
          [stackedY]="true"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#4DB6AC',
              pointBackgroundColor: '#4DB6AC',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4DB6AC'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.PreparationTimeAveragePerSaleMethodBranch' | translate"
          [tooltipEnabled]="true"></sepidz-bar-chart>
        <sepidz-bar-chart
          *hasPermission="['RestaurantSale:Dashboard/ReadDriverTimeUsedAverage', 'Same']"
          [data]="model.Chart.ReadDriverTimeUsedAverage"
          [legend]="false"
          [ratio]="1000000"
          [legend]="false"
          [stackedX]="true"
          [stackedY]="true"
          [colors]="[
            {
              backgroundColor: '#80CBC4',
              borderColor: '#4DB6AC',
              pointBackgroundColor: '#4DB6AC',
              pointBorderColor: '#fff',
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: '#4DB6AC'
            }
          ]"
          [title]="'ClientApp.FrontOffice.Review.Dashboard.DriverTimeUsedAverage' | translate"
          [tooltipEnabled]="true"></sepidz-bar-chart>
      </div>
    </div>
  </div>
</section>
